// const urlRender = "https://back-rocio-reformas.onrender.com";
const urllocal = "http://localhost:4501";

export const currentUrl = urllocal;
